<template>
  <JsonTreeView
    v-if="settingsDevStore.devModeEnabled && settingsDevStore.devDebugEnabled"
    :json="json"
    v-bind="$attrs"
  />
</template>

<script lang="ts" setup>
import { JsonTreeView } from 'json-tree-view-vue3'
import { useSettingsDevStore } from '@/stores/settings/settings-dev'

type JsonTreeViewProps = ExtractPropTypes<(typeof JsonTreeView)['props']>

defineProps({
  json: {
    type: String as PropType<JsonTreeViewProps['json']>,
    required: true,
  },
})

const settingsDevStore = useSettingsDevStore()
</script>
